import Chip from "@material-ui/core/Chip";

interface Props {
  action: string;
}

const colors = {

  Added: "#22C55E",

  Modified: "#3B82F6",

  Deleted: "#EF4444",

  Total: "#6366F1",

};

const ActionChip = ({
  action,
}: Props) => (

  <Chip
    label={action}
    size="small"
    style={{

      background:
        colors[action as keyof typeof colors],

      color: "#fff",

      fontWeight: 700,

      width: 90,

    }}
  />

);

export default ActionChip;